export default __webpack_public_path__ + "static/media/acceY.fb2b7ac9.svg";